import styled from '@emotion/styled'

export const Container = styled.div`
  align-items: flex-start;
  align-self: stretch;
  background: var(--System-White, #fff);
  border-radius: 5.252px;
  box-shadow: -3.501px 3.501px 19.258px -1.751px rgba(67, 67, 67, 0.15);
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  margin: 0 1.5rem;
  padding: 15.756px;
  width: 100%;
`
